import {
  Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-attachments',
  templateUrl: './attachments.component.html',
  styleUrls: [ './attachments.component.scss' ],
})

export class AttachmentsComponent implements OnInit {
  @ViewChild('fileInput') fileInput!: ElementRef;
  @Output() updateCourseObject = new EventEmitter<object>();
  @Output() stepBack = new EventEmitter<any>();
  @Output() closeDialogEmitter = new EventEmitter<any>();
  @Output() stepForward = new EventEmitter<boolean>();
  @Input() course: any;
  @Input() isEditMode: any;
  fileTypeInS3 = 'COURSE_DOCUMENT' as const;
  logoSrc!: string;

  updatedCourse: any;
  constructor(public dialog: MatDialog) { }

  ngOnInit(): void {
    this.updatedCourse = this.course;
  }

  updateLocalCourseParameter = (event: any, parameter: string) => {
    this.updatedCourse[parameter] = event;
  }

  stepBackward = () => {
    this.stepBack.emit(true);
  }

  closeDialog = () => {
    this.closeDialogEmitter.emit();
  }

  updateCourse = () => {
    this.stepForward.emit(true);
  }

}
